riot.tag2('bbc-notifications-home-view', '<header class="notifications__header notifications__header--js {\'shadowAdded\': shadowAdded}"> <h2 class="notification-title"><i1-8n>Notifications</i1-8n></h2> <ul class="notification-header-icons"> <li><a href="javascript:;" class="notifications__settings--js" onkeydown="{this.onSettingsKeydown}" onclick="{parent.openSettings}"><img class="setting-icon notifications-image" riot-src="{this.basePath + \'/svg/setting.svg\'}" alt="Settings"><span class="notifications-brevier"><i1-8n>Settings</i1-8n></span></a></li> </ul> </header> <div class="notification-panel" style="display: block;"> <bbc-notifications-list if="{opts.notifications.length}" main-app="{opts.mainApp}" component-app="{opts.componentApp}" notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}"></bbc-notifications-list> <div if="{!opts.notifications.length}" id="no-notifications" class="no-notifications"> <div class="noVariant--element"> <p class="notifications-long-primer"><i1-8n>copy.noNotifications1</i1-8n></p> <p class="notifications-long-primer"><i1-8n>copy.noNotifications2</i1-8n></p> </div> </div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

this.basePath = opts.mainApp.basePath;

this.onSettingsKeydown = function (e) {
    console.log('Settings press', e);
    if (e.keyCode === 9 && e.shiftKey) {
        // Tab backwards
        var closeBtn = document.querySelector('.notifications-keyboard-access--close');

        if (closeBtn) {
            closeBtn.focus();
            return false;
        }

        var lastNotif = document.querySelector('.notification-items .notification-item:last-child a');

        if (lastNotif) {
            lastNotif.focus();
            return false;
        }
    } else if (e.keyCode === 13) {
        // Enter
        _this.updateFocus = '.notifications__settings__back-btn--js';
    } else if (e.keyCode === 9 && !e.shiftKey) {
        // Tab forwards
        if (!document.querySelectorAll('bbc-notifications-list .notification-item').length) {
            _this.update({ showKeyboardAccess: true });
        }
    }

    return true;
};
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-home-view.tag
 ** module id = 21
 ** module chunks = 0
 **/